// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Scoped overrides for the shared tree-select classes (.subcategory / .selectcategory /
   .makeCategory_subCategory) defined globally in index.css and reused by a few other
   pages — kept local to this page via :global so those pages are unaffected. */
.AddSubCategory_treeWrap__zNnWA .subcategory {
  border: 1px solid #E7E9F1;
  border-radius: 12px;
  background: #ffffff;
  overflow: hidden;
}

.AddSubCategory_treeWrap__zNnWA .selectcategory {
  background: #F5F3FE;
  color: #4c2fb3;
  font-weight: 700;
  font-size: 13px;
  border: none;
  border-radius: 0;
  padding: 10px 14px;
}

.AddSubCategory_treeWrap__zNnWA .makeCategory_subCategory {
  padding: 10px 14px;
}

.AddSubCategory_treeWrap__zNnWA .makeCategory_subCategory .category_list {
  max-height: 240px;
}

.AddSubCategory_treeWrap__zNnWA .makeCategory_subCategory ul li span {
  color: #4c2fb3;
  font-weight: 700;
}

.AddSubCategory_treeWrap__zNnWA .makeCategory_subCategory ul li input[type="checkbox"] {
  accent-color: #4c2fb3;
  width: 15px;
  height: 15px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/New Category/AddSubCategory.module.css"],"names":[],"mappings":"AAAA;;+EAE+E;AAC/E;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd","sourcesContent":["/* Scoped overrides for the shared tree-select classes (.subcategory / .selectcategory /\n   .makeCategory_subCategory) defined globally in index.css and reused by a few other\n   pages — kept local to this page via :global so those pages are unaffected. */\n.treeWrap :global(.subcategory) {\n  border: 1px solid #E7E9F1;\n  border-radius: 12px;\n  background: #ffffff;\n  overflow: hidden;\n}\n\n.treeWrap :global(.selectcategory) {\n  background: #F5F3FE;\n  color: #4c2fb3;\n  font-weight: 700;\n  font-size: 13px;\n  border: none;\n  border-radius: 0;\n  padding: 10px 14px;\n}\n\n.treeWrap :global(.makeCategory_subCategory) {\n  padding: 10px 14px;\n}\n\n.treeWrap :global(.makeCategory_subCategory .category_list) {\n  max-height: 240px;\n}\n\n.treeWrap :global(.makeCategory_subCategory ul li span) {\n  color: #4c2fb3;\n  font-weight: 700;\n}\n\n.treeWrap :global(.makeCategory_subCategory ul li input[type=\"checkbox\"]) {\n  accent-color: #4c2fb3;\n  width: 15px;\n  height: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"treeWrap": `AddSubCategory_treeWrap__zNnWA`
};
export default ___CSS_LOADER_EXPORT___;
